export default __webpack_public_path__ + "static/media/valeria2.fd043f5c.jpg";